<script module>
  import { resolve } from '$app/paths'
  import { helpPath } from '$lib/help/path'

  export const meta = {
    title: 'Contests',
    teaser:
      'Learn how Pausly Plus subscribers can boost engagement by creating contests,\nsetting rules, and inviting users. Details include joining methods, point\nsystems with modifications, and features for organizations.',
    sort: 7,
  }
</script>

<p>Contests are a fantastic way to boost motivation and engagement.</p>
<p>
  Anyone subscribing to the Pausly Plus plan is empowered to create contests and
  invite users, including those on the free plan.
</p>
<p>
  Each contest is defined by a start and end date alongside specific rules. For
  instance, you might limit the countable number of sessions per day within the
  contest framework.
</p>
<p>
  To join a contest, users must first accept their invitation by the contest
  organizer. This can be done in two ways: by clicking "join" after following
  the contest link, or by electing to join when prompted at the end of a session
  if they've been added to a contest.
</p>
<h3>Point System</h3>
<p>
  Contests adhere to the
  <a href={resolve(helpPath('product/point-and-level-system'))}
    >general point system</a
  >, with two key modifications:
</p>
<ul>
  <li>
    Participants begin with a x1.0 multiplier, which doesn't affect their
    overall multiplier outside of the contest.
  </li>
  <li>
    At the discretion of the contest creator, not every session conducted on the
    same day may count towards the contest.
  </li>
</ul>
<h3>Organizations</h3>
<p>
  If you are part of an organization, it's straightforward to invite entire
  teams to participate in a contest, sidestepping the need to add members one by
  one.
</p>
<p>
  Furthermore, organization admins have the privilege of designating a contest
  as an official event. Official contests are tagged accordingly and featured on
  the organization's contests page, enhancing visibility and engagement.
</p>
